import { TypographyWrapperDataProvider } from '../types';

const fallback = () => {};

const dp: TypographyWrapperDataProvider = {
  getFontFaceDeclarations: fallback,
};

export const getTypographyWrapperDataProvider = (): TypographyWrapperDataProvider => dp;
